import { Marquee } from "@/components/ui/marquee";

const credentials = ["MIT", "Harvard", "Fortune 500", "Top AI Startups"];

const CredentialsBanner = () => {
  return (
    <section className="pt-8 pb-16 overflow-hidden">
      <p className="text-center text-sm text-muted-foreground mb-4">
        Led by developers from
      </p>
      <Marquee
        items={credentials}
        speedSeconds={15}
        renderItem={(credential) => (
          <div className="flex-shrink-0 px-6 md:px-10">
            <span className="text-sm md:text-base font-medium text-foreground/60">
              {credential}
            </span>
          </div>
        )}
      />
    </section>
  );
};

export default CredentialsBanner;
